export default {
  'form.basicform.basic.title': '基础表单',
  'form.basicform.basic.description':
    '表单页用于向用户收集或验证信息，基础表单常见于数据项较少的表单场景。',

  'form.basicform.email.required': '请输入邮箱地址！',
  'form.basicform.email.wrong-format': '邮箱地址格式错误！',
  'form.basicform.userName.required': '请输入用户名!',
  'form.basicform.password.required': '请输入密码！',
  'form.basicform.password.twice': '两次输入的密码不匹配!',
  'form.basicform.strength.msg': '请至少输入 6 个字符。请不要使用容易被猜到的密码。',
  'form.basicform.strength.strong': '强度：强',
  'form.basicform.strength.medium': '强度：中',
  'form.basicform.strength.short': '强度：太短',
  'form.basicform.confirm-password.required': '请确认密码！',
  'form.basicform.phone-number.required': '请输入手机号！',
  'form.basicform.phone-number.wrong-format': '手机号格式错误！',
  'form.basicform.verification-code.required': '请输入验证码！',
  'form.basicform.title.required': '请输入标题',
  'form.basicform.date.required': '请选择起止日期',
  'form.basicform.goal.required': '请输入目标描述',
  'form.basicform.standard.required': '请输入衡量标准',

  'form.basicform.form.get-captcha': '获取验证码',
  'form.basicform.captcha.second': '秒',
  'form.basicform.form.optional': '（选填）',
  'form.basicform.form.submit': '提交',
  'form.basicform.form.save': '保存',
  'form.basicform.email.placeholder': '邮箱',
  'form.basicform.password.placeholder': '至少8位密码，区分大小写',
  'form.basicform.confirm-password.placeholder': '确认密码',
  'form.basicform.phone-number.placeholder': '手机号',
  'form.basicform.verification-code.placeholder': '验证码',
  'form.basicform.title.label': '标题',
  'form.basicform.title.placeholder': '给目标起个名字',
  'form.basicform.date.label': '起止日期',
  'form.basicform.placeholder.start': '开始日期',
  'form.basicform.placeholder.end': '结束日期',
  'form.basicform.goal.label': '目标描述',
  'form.basicform.goal.placeholder': '请输入你的阶段性工作目标',
  'form.basicform.standard.label': '衡量标准',
  'form.basicform.standard.placeholder': '请输入衡量标准',
  'form.basicform.client.label': '客户',
  'form.basicform.label.tooltip': '目标的服务对象',
  'form.basicform.client.placeholder': '请描述你服务的客户,内部客户直接 姓名/工号',
  'form.basicform.invites.label': '邀评人',
  'form.basicform.invites.placeholder': '请直接 姓名/工号,最多可邀请 5 人',
  'form.basicform.weight.label': '权重',
  'form.basicform.weight.placeholder': '请输入',
  'form.basicform.public.label': '目标公开',
  'form.basicform.label.help': '客户、邀评人默认被分享',
  'form.basicform.radio.public': '公开',
  'form.basicform.radio.partially-public': '部分公开',
  'form.basicform.radio.private': '不公开',
  'form.basicform.publicUsers.placeholder': '公开给',
  'form.basicform.option.A': '同事甲',
  'form.basicform.option.B': '同事乙',
  'form.basicform.option.C': '同事丙',
};
